import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onAddinTrigger = action("onAddinTrigger", event => ({
    event,
    owaType: "addIn",
})) as OwaNovaActionUnion<"addIn">;
